module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Spark.3ce6a5ca.png";